import { api } from 'lib/httpClient';
import { useQuery } from '@tanstack/react-query';
import { Api } from 'further-types/investor-reporting';
import { ApiResponse } from 'further-types/api';

async function fetchInvestee({ queryKey }) {
  const [, params] = queryKey;
  const {
    data: { data },
  } = await api.post<ApiResponse<Api.GetInvesteeListResponse>>(
    'investor-reporting/investee',
    params,
  );
  return data;
}

export function useReportingInvestee({ firmId, submitDate, fundIds, enabled }) {
  return useQuery({
    queryKey: ['reporting-investee', { firmId, submitDate, fundIds }],
    queryFn: fetchInvestee,
    enabled,
    placeholderData: undefined,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
}
